import EmptyState from '@/components/EmptyState';
import { Clock01Icon } from '@/icons';
import { formatDate, formatTime } from '@/utils';
import { Button } from 'antd';
import SectionCard from '../../../../../../components/SectionCard';

export default function PendingCorrections() {
  return (
    <SectionCard className="max-w-full mt-6">
      <SectionCard.Title>Pending Corrections</SectionCard.Title>

      {/* SCROLL WRAPPER */}
      <SectionCard.Content className="px-6 max-h-[550px]">
        {data?.length > 5 ? (
          data?.map((item) => (
            <div
              key={item.id}
              className="p-4 rounded-xl border border-gray-700"
            >
              {/* TOP SIDE */}
              <div className="flex justify-between gap-4">
                <div>
                  <h3 className="text-white text-xl font-medium">
                    {item.name}
                  </h3>

                  <div className="space-x-1">
                    <span className="text-white text-sm font-light ">
                      {formatDate(item?.date)}
                    </span>
                    <span>•</span>
                    <span className="text-white text-sm ">
                      Check-In: {formatTime(item?.date)}
                    </span>
                  </div>
                </div>

                <span className="text-white text-xl font-medium">
                  {formatTime(item?.createdAt)}
                </span>
              </div>

              {/* BOTTOM SIDE */}
              <div className="flex justify-between gap-3 mt-4 pt-4 border-t border-gray-700">
                <Button
                  className="!border-teal-500 !text-teal-500 !bg-[#1E293B] !text-base !rounded-lg px-5 py-1"
                  type="default"
                >
                  Reject
                </Button>
                <Button
                  className="!bg-teal-500 !text-neutral-700 !border-none !text-base !rounded-lg px-5 py-1"
                  type="primary"
                >
                  Approve
                </Button>
              </div>
            </div>
          ))
        ) : (
          <div className="py-5">
            <EmptyState
              className="py-5"
              icon={<Clock01Icon size={40} />}
              title="No Pending Corrections"
              description="All attendance records are up to date. Any correction requests submitted by employees will appear here for your review."
            />
          </div>
        )}
      </SectionCard.Content>
    </SectionCard>
  );
}

const data = [
  {
    id: 1,
    name: 'Afsana Tabassum',
    date: '2025-11-23T06:27:00.000Z',
    createdAt: '2025-11-23T06:30:00.000Z',
  },
  {
    id: 2,
    name: 'Afsana Tabassum',
    date: '2025-11-23T06:27:00.000Z',
    createdAt: '2025-11-23T06:30:00.000Z',
  },
  {
    id: 3,
    name: 'Afsana Tabassum',
    date: '2025-11-23T06:27:00.000Z',
    createdAt: '2025-11-23T06:30:00.000Z',
  },
  {
    id: 4,
    name: 'Afsana Tabassum',
    date: '2025-11-23T06:27:00.000Z',
    createdAt: '2025-11-23T06:30:00.000Z',
  },
];
